"use client";
import React, { useContext, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Context } from "../contexts/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { getData, postData } from "../../lib/utils";

function ReplacePhoto(props) {
  const [photoFiles, setPhotoFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const xhrRefs = useRef({});
  const [totalFileUploaded, setTotalFileUploaded] = useState(0);

  const { value, progress } = useContext(Context);
  const [appState] = value;
  const {
    currentFolderData,
    currentGalleryData,
  } = appState;

  const { showProgressBar, cancelledIdsRef, stopProgress } = progress;

  
  const sanitizeFileName = (name) =>
    name.replace(/[^a-zA-Z0-9_.]/g, "");

  // --- File Change ---
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    setPhotoFiles(files);
    //props?.replaceStart(props?.photoId);
  };

  useEffect(() => {
    if (photoFiles.length > 0) handleUpload();
  }, [photoFiles]);

  // --- Backend APIs ---
  const startMultipartUpload = async (fileName, fileType) => {
    const s3Key = `${currentFolderData.adminId}/${currentFolderData.id}/${currentGalleryData._id}/${fileName}`;
    return await postData(
      `products/start-multipart-upload?fileName=${encodeURIComponent(
        s3Key
      )}&fileType=${fileType}`
    );
  };

  const getPartUrl = async (fileName, uploadId, partNumber) => {
    const s3Key = `${currentFolderData.adminId}/${currentFolderData.id}/${currentGalleryData._id}/${fileName}`;
    return await getData(
      `products/get-part-url?fileName=${encodeURIComponent(
        s3Key
      )}&uploadId=${uploadId}&partNumber=${partNumber}`
    );
  };

  const completeMultipartUpload = async (_fileName, uploadId, parts) => {
    const fileName = `${currentFolderData.adminId}/${currentFolderData.id}/${currentGalleryData._id}/${_fileName}`;
    return await postData(`products/complete-multipart-upload`, {
      fileName,
      uploadId,
      parts,
    });
  };

  // --- Upload Logic ---
  const uploadMultipartFile = async (file, uniqueId) => {
    const cleanName = sanitizeFileName(file.name);

    // Images usually smaller → smaller chunk size
    const chunkSize = Math.min(
      Math.max(file.size / 100, 5 * 1024 * 1024),
      20 * 1024 * 1024
    );

    const totalParts = Math.ceil(file.size / chunkSize);

    showProgressBar?.(cleanName, 0, uniqueId, "uploading");

    try {
      const { uploadId } = await startMultipartUpload(cleanName, file.type);
      let parts = [];
      let uploadedBytes = 0;

      for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
        const start = (partNumber - 1) * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const { url } = await getPartUrl(cleanName, uploadId, partNumber);

        const xhr = new XMLHttpRequest();
        xhrRefs.current[uniqueId] = xhr;

        await new Promise((resolve, reject) => {
          xhr.open("PUT", url, true);

          if (cancelledIdsRef?.has?.(uniqueId)) {
            xhr.abort();
            showProgressBar?.(cleanName, 0, uniqueId, "cancelled");
            return reject("Upload cancelled");
          }

          xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
              uploadedBytes = start + event.loaded;
              const percent = Math.round((uploadedBytes / file.size) * 100);
              showProgressBar?.(cleanName, percent, uniqueId, "uploading");
              props?.showProgressBar?.(cleanName, percent);
            }
          };

          xhr.onload = () => {
            if (xhr.status === 200) {
              const eTag = xhr.getResponseHeader("ETag");
              parts.push({ ETag: eTag, PartNumber: partNumber });
              resolve();
            } else reject(`Part ${partNumber} failed`);
          };

          xhr.onerror = () => reject(`Network error`);
          xhr.send(chunk);
        });
      }

      await completeMultipartUpload(cleanName, uploadId, parts);

      setTotalFileUploaded((prev) => prev + 1);

      // 🔥 Important change
      props?.replaceUploadPhotoDone?.(
        cleanName,
        uniqueId,
        props.photoId,
        props.oldPhotoUrl
      );

      showProgressBar?.(cleanName, 100, uniqueId, "completed");
      stopProgress(uniqueId);

    } catch (err) {
      console.error("Upload error:", err);
      showProgressBar?.(
        cleanName,
        0,
        uniqueId,
        cancelledIdsRef?.has?.(uniqueId) ? "cancelled" : "failed"
      );
    } finally {
      delete xhrRefs.current[uniqueId];
    }
  };

  const handleUpload = async () => {
    setIsUploading(true);

    for (const file of photoFiles) {
      const uniqueId = uuidv4();
      try {
        await uploadMultipartFile(file, uniqueId);
      } catch (err) {
        console.error("Upload failed:", err);
      }
    }

    setIsUploading(false);
    setPhotoFiles([]);
  };

  return (
    <div>
      <input
        type="file"
        accept="image/*"   // 🔥 changed
        onChange={handleFileChange}
        id="fileReplacePhoto"
        style={{ display: "none" }}
      />

    <button
  onClick={(e) => {
    e.stopPropagation();
    document.getElementById("fileReplacePhoto")?.click();
  }}
  className="flex items-center gap-x-2 w-full text-left  hover:text-gray-100"
>
  <FontAwesomeIcon icon={faRightLeft} />
</button>
    </div>
  );
}

export default ReplacePhoto;